export default {
	AF: '🇦🇫',
	AX: '🇦🇽',
	AL: '🇦🇱',
	DZ: '🇩🇿',
	AS: '🇦🇸',
	AD: '🇦🇩',
	AO: '🇦🇴',
	AI: '🇦🇮',
	AQ: '🇦🇶',
	AG: '🇦🇬',
	AR: '🇦🇷',
	AM: '🇦🇲',
	AW: '🇦🇼',
	AU: '🇦🇺',
	AT: '🇦🇹',
	AZ: '🇦🇿',
	BS: '🇧🇸',
	BH: '🇧🇭',
	BD: '🇧🇩',
	BB: '🇧🇧',
	BY: '🇧🇾',
	BE: '🇧🇪',
	BZ: '🇧🇿',
	BJ: '🇧🇯',
	BM: '🇧🇲',
	BT: '🇧🇹',
	BO: '🇧🇴',
	BA: '🇧🇦',
	BW: '🇧🇼',
	BR: '🇧🇷',
	IO: '🇮🇴',
	VG: '🇻🇬',
	BN: '🇧🇳',
	BG: '🇧🇬',
	BF: '🇧🇫',
	BI: '🇧🇮',
	KH: '🇰🇭',
	CM: '🇨🇲',
	CA: '🇨🇦',
	CV: '🇨🇻',
	BQ: '🇧🇶',
	KY: '🇰🇾',
	CF: '🇨🇫',
	TD: '🇹🇩',
	CL: '🇨🇱',
	CN: '🇨🇳',
	CX: '🇨🇽',
	CC: '🇨🇨',
	CO: '🇨🇴',
	KM: '🇰🇲',
	CG: '🇨🇬',
	CK: '🇨🇰',
	CR: '🇨🇷',
	HR: '🇭🇷',
	CU: '🇨🇺',
	CW: '🇨🇼',
	CY: '🇨🇾',
	CZ: '🇨🇿',
	CD: '🇨🇩',
	DK: '🇩🇰',
	DJ: '🇩🇯',
	DM: '🇩🇲',
	DO: '🇩🇴',
	EC: '🇪🇨',
	EG: '🇪🇬',
	SV: '🇸🇻',
	GQ: '🇬🇶',
	ER: '🇪🇷',
	EE: '🇪🇪',
	ET: '🇪🇹',
	FK: '🇫🇰',
	FO: '🇫🇴',
	FM: '🇫🇲',
	FJ: '🇫🇯',
	FI: '🇫🇮',
	FR: '🇫🇷',
	GF: '🇬🇫',
	PF: '🇵🇫',
	TF: '🇹🇫',
	GA: '🇬🇦',
	GM: '🇬🇲',
	GE: '🇬🇪',
	DE: '🇩🇪',
	GH: '🇬🇭',
	GI: '🇬🇮',
	GR: '🇬🇷',
	GL: '🇬🇱',
	GD: '🇬🇩',
	GP: '🇬🇵',
	GU: '🇬🇺',
	GT: '🇬🇹',
	GN: '🇬🇳',
	GW: '🇬🇼',
	GY: '🇬🇾',
	HT: '🇭🇹',
	HN: '🇭🇳',
	HK: '🇭🇰',
	HU: '🇭🇺',
	IS: '🇮🇸',
	IN: '🇮🇳',
	ID: '🇮🇩',
	IR: '🇮🇷',
	IQ: '🇮🇶',
	IE: '🇮🇪',
	IM: '🇮🇲',
	IL: '🇮🇱',
	IT: '🇮🇹',
	CI: '🇨🇮',
	JM: '🇯🇲',
	JP: '🇯🇵',
	JE: '🇯🇪',
	JO: '🇯🇴',
	KZ: '🇰🇿',
	KE: '🇰🇪',
	KI: '🇰🇮',
	XK: '🇽🇰',
	KW: '🇰🇼',
	KG: '🇰🇬',
	LA: '🇱🇦',
	LV: '🇱🇻',
	LB: '🇱🇧',
	LS: '🇱🇸',
	LR: '🇱🇷',
	LY: '🇱🇾',
	LI: '🇱🇮',
	LT: '🇱🇹',
	LU: '🇱🇺',
	MO: '🇲🇴',
	MK: '🇲🇰',
	MG: '🇲🇬',
	MW: '🇲🇼',
	MY: '🇲🇾',
	MV: '🇲🇻',
	ML: '🇲🇱',
	MT: '🇲🇹',
	MH: '🇲🇭',
	MQ: '🇲🇶',
	MR: '🇲🇷',
	MU: '🇲🇺',
	YT: '🇾🇹',
	MX: '🇲🇽',
	MD: '🇲🇩',
	MC: '🇲🇨',
	MN: '🇲🇳',
	ME: '🇲🇪',
	MS: '🇲🇸',
	MA: '🇲🇦',
	MZ: '🇲🇿',
	MM: '🇲🇲',
	NA: '🇳🇦',
	NR: '🇳🇷',
	NP: '🇳🇵',
	NL: '🇳🇱',
	NC: '🇳🇨',
	NZ: '🇳🇿',
	NI: '🇳🇮',
	NE: '🇳🇪',
	NG: '🇳🇬',
	NU: '🇳🇺',
	NF: '🇳🇫',
	KP: '🇰🇵',
	MP: '🇲🇵',
	NO: '🇳🇴',
	OM: '🇴🇲',
	PK: '🇵🇰',
	PW: '🇵🇼',
	PS: '🇵🇸',
	PA: '🇵🇦',
	PG: '🇵🇬',
	PY: '🇵🇾',
	PE: '🇵🇪',
	PH: '🇵🇭',
	PN: '🇵🇳',
	PL: '🇵🇱',
	PT: '🇵🇹',
	PR: '🇵🇷',
	QA: '🇶🇦',
	RE: '🇷🇪',
	RO: '🇷🇴',
	RU: '🇷🇺',
	RW: '🇷🇼',
	SH: '🇸🇭',
	KN: '🇰🇳',
	LC: '🇱🇨',
	PM: '🇵🇲',
	VC: '🇻🇨',
	WS: '🇼🇸',
	SM: '🇸🇲',
	ST: '🇸🇹',
	SA: '🇸🇦',
	SN: '🇸🇳',
	RS: '🇷🇸',
	SC: '🇸🇨',
	SL: '🇸🇱',
	SG: '🇸🇬',
	SX: '🇸🇽',
	SK: '🇸🇰',
	SI: '🇸🇮',
	SB: '🇸🇧',
	SO: '🇸🇴',
	ZA: '🇿🇦',
	GS: '🇬🇸',
	KR: '🇰🇷',
	SS: '🇸🇸',
	ES: '🇪🇸',
	LK: '🇱🇰',
	SD: '🇸🇩',
	SR: '🇸🇷',
	SJ: '🇸🇯',
	SZ: '🇸🇿',
	SE: '🇸🇪',
	CH: '🇨🇭',
	SY: '🇸🇾',
	TW: '🇹🇼',
	TJ: '🇹🇯',
	TZ: '🇹🇿',
	TH: '🇹🇭',
	TL: '🇹🇱',
	TG: '🇹🇬',
	TK: '🇹🇰',
	TO: '🇹🇴',
	TT: '🇹🇹',
	TN: '🇹🇳',
	TR: '🇹🇷',
	TM: '🇹🇲',
	TC: '🇹🇨',
	TV: '🇹🇻',
	UG: '🇺🇬',
	UA: '🇺🇦',
	AE: '🇦🇪',
	GB: '🇬🇧',
	US: '🇺🇸',
	UM: '🇺🇲',
	VI: '🇻🇮',
	UY: '🇺🇾',
	UZ: '🇺🇿',
	VU: '🇻🇺',
	VA: '🇻🇦',
	VE: '🇻🇪',
	VN: '🇻🇳',
	WF: '🇼🇫',
	EH: '🇪🇭',
	YE: '🇾🇪',
	ZM: '🇿🇲',
	ZW: '🇿🇼'
};